import styled from "styled-components";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";

export const MultiSelectPicker = styled(Autocomplete)`
  padding: 12px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon
    .MuiAutocomplete-inputRoot {
    padding-right: 10px;
  }
`;

export const Field = styled(TextField)`
  margin-top: 5px;
`;
